module.exports = __webpack_public_path__ + "static/img/role0010.95c9d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0010.jpg
// module id = 3NhG
// module chunks = 1